import {h, Fragment} from "preact"
import Products from "./Products"
import Toolbar from "./Toolbar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"
import { categoryHeader } from "../helpers"


export function CategoryBody({ loading, foundProducts }) {
    if (loading) return <Loader />

    console.log("HAEEDER", categoryHeader);
    return (
        foundProducts ? <>
            {/* see: https://nostosolutions.atlassian.net/browse/FEA-11645?focusedCommentId=386340 */}
            {/* <div dangerouslySetInnerHTML={{ __html: categoryHeader }}></div> */}
            {/* <SelectedFilters /> */}
            <Toolbar />
            <Products />
            <BottomToolbar />
        </> : <NoResults />
    )
}

export function CategoryBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            {/* <SelectedFilters /> */}
            <Toolbar />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("category", CategoryBodyInfiniteScroll)
export default wrapContent("category", CategoryBody)
